import styles from './IconFeatureGridTitle.scss';

import React from 'react';

import { Grid } from 'src/components/Grid/Grid';
import { GridContainer } from 'src/components/GridContainer/GridContainer';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { AppType } from 'src/services/cms/typesUtil';

type IconFeatureGridProps = AppType.Component<{
  title: string;
  titleColor: string;
}>;

export const IconFeatureGridTitle: React.FC<IconFeatureGridProps> = ({
  title,
  titleColor,
}) => {
  return (
    <GridContainer justifyContent="center" className={styles.iconFeatureGridContainer}>
      <Grid item xs={12} md={10} lg={6} xl={8}>
        {(title) ? (
          <TextV2
            hasId
            isMarkdown
            value={title}
            tagName="h2"
            variant="h2-bold"
            className={styles.iconFeatureGridContainerTitle}
            style={{ color: titleColor }}
          />
        ) : null}
      </Grid>
    </GridContainer>
  );
};
